import { render, staticRenderFns } from "./real_time.vue?vue&type=template&id=0c764ddc&scoped=true&"
import script from "./real_time.vue?vue&type=script&lang=js&"
export * from "./real_time.vue?vue&type=script&lang=js&"
import style0 from "./real_time.vue?vue&type=style&index=0&id=0c764ddc&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c764ddc",
  null
  
)

export default component.exports